import * as React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import addressMapsLink from '../../../../helpers/addressMapsLink';
import type { TaxonomyLocation } from '../../../../types/uncinc_profile/taxonomy';

interface LocationProjectProps extends React.ComponentPropsWithoutRef<'span'> {
  entity: ImmutableEntity<TaxonomyLocation>;
}

const TaxonomyLocationProject: React.FC<LocationProjectProps> = ({ entity, ...props }) => {
  const term = entity.toJS();
  const name = term.name[0].value;
  const address = term.field_address[0];

  if (!address) {
    return null;
  }

  const {
    address_line1: addressLine,
    postal_code: postalCode,
    locality: city,
  } = address;

  const url = addressMapsLink(address, name);

  return (
    <span {...props}>
      <CoreLink href={url} title={addressLine} />, {postalCode} {city}
    </span>
  );
};

export default TaxonomyLocationProject;
